// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box {\n  margin-top: -15% !important;\n}\n.dbConfirmButton {\n  background-color: #f56c6c !important;\n  border-color: #f56c6c !important;\n}\n.word .el-dialog__body {\n  padding: 0px;\n}", ""]);
// Exports
module.exports = exports;
